import { memo } from "react"

import type { HomeService } from "@be-miniapp/api"
import { Skeleton } from "@be-miniapp/ui/components/ui/skeleton"

import { ProgressiveIcon } from "./progressive-icon"

interface HomeIconScrollListProps {
  listOfServices: HomeService[]
  lang: string
  onServiceClick: (service: HomeService) => void
  isLoading: boolean
}

const HomeIconScrollList = memo(
  ({
    listOfServices,
    onServiceClick,
    lang,
    isLoading,
  }: HomeIconScrollListProps) => {
    if (isLoading)
      return (
        <div className="animate-fade-slide-up-delay px-3 pt-3">
          <div className="grid grid-cols-4 gap-x-2 gap-y-4">
            {Array.from({ length: 4 }).map((_, idx) => (
              <Skeleton
                key={idx}
                className="mx-auto flex h-11 w-11 shrink-0 cursor-pointer items-center gap-1 truncate rounded-full bg-gray-300/50 text-gray-700 text-sm"
              />
            ))}
          </div>
        </div>
      )

    if (!listOfServices) return null

    return (
      <div className="animate-fade-slide-up-delay px-3 pt-3">
        <div className="grid grid-cols-4 gap-x-2 gap-y-4">
          {listOfServices?.map((service, i) => {
            return (
              <div
                key={service.id}
                onClick={() => onServiceClick(service)}
                className="flex cursor-pointer flex-col items-center gap-2"
              >
                <div key={i} className="relative">
                  <ProgressiveIcon
                    src={service.image}
                    className="h-auto w-11"
                  />
                  {service.is_enabled_label ? (
                    <div className="absolute -top-1 -right-3 z-20">
                      <div className="rounded-md bg-red-700 px-1 py-0 font-semibold text-[0.5rem] text-white leading-3">
                        {service.label[lang]}
                      </div>
                    </div>
                  ) : null}
                </div>
                <span className="text-center text-[0.78rem]">
                  {service.title[lang]}
                </span>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
)

HomeIconScrollList.displayName = "HomeIconScrollList"

export { HomeIconScrollList }
